<template>
  <div>
    <v-row class="mb-0 pb-0">
      <v-col
        cols="12"
        sm="12"
        md="8"
        class="py-0 my-0"
      >
        <slot name="urlCreate" />
      </v-col>

      <v-col
        v-if="!noSearch"
        cols="12"
        sm="12"
        md="4"
        class="py-0 my-0"
      >
        <v-row>
          <v-text-field
            v-model.trim="search"
            class="py-0 my-0"
            label="Search"
            single-line
            hide-details
            :error-messages="searchError ? 'Invalid input !' : ''"
          />
          <slot name="actions" />
        </v-row>
      </v-col>
    </v-row>

    <div
      v-if="actions != undefined && selected.length > 0"
      class="row justify-content-md-center mb-10"
    >
      <div class="col-md-auto">
        <button
          v-for="action in actions"
          :key="action.text"
          :class="action.class"
          @click="bindAction(action)"
        >
          <span
            v-if="action.icon.length > 0"
            :class="action.icon"
          />
          {{ action.text }}
        </button>
      </div>
    </div>
    <v-layout
      v-resize="onResize"
      column
      style="padding-top:10px"
    >
      <v-data-table
        v-model="selected"
        dense
        :headers="headers_"
        :items="data_"
        :options.sync="pagination"
        :server-items-length="totalData_"
        :loading="loading"
        :show-select="checking"
        :item-key="checking_key"
        :class="textColor + '--text'"
      >
        <template v-slot:header.button="{ props }">
          Actions
        </template>

        <template v-slot:body="{ items, isSelected, isMobile }">
          <tr v-if="items.length < 1 && search == ''">
            <td
              class="text-center text-muted"
              :colspan="headers_.length"
            >
              No data available
            </td>
          </tr>

          <tr v-else-if="items.length < 1 && search !== ''">
            <td
              class="text-center text-muted"
              :colspan="headers_.length"
            >
              <div
                :value="true"
                class="error--text"
              >
                Your search for "{{ search }}" found no results.
              </div>
            </td>
          </tr>

          <tr
            v-for="(item, key) in items"
            v-else-if="!isMobile"
            :key="key"
          >
            <template
              :active="isSelected"
              @click="isSelected = !isSelected"
            >
              <td v-if="checking">
                <v-checkbox
                  :input-value="isSelected"
                  primary
                  hide-details
                />
              </td>

              <td
                v-for="hitem in headers_"
                v-else
                :key="hitem.value"
                class="text-center"
              >
                <span v-if="!hitem.slot">
                  {{ getValue(item, hitem.value) }}
                </span>
                <span v-else>
                  <slot
                    :name="hitem.slot"
                    :item="item"
                  />
                </span>
              </td>
            </template>
          </tr>

          <tr
            v-for="(item, key) in items"
            v-else
            :key="key"
            class="v-data-table__mobile-table-row"
          >
            <template
              :active="isSelected"
              @click="isSelected = !isSelected"
            >
              <td
                v-if="checking"
                class="v-data-table__mobile-row"
              >
                <v-checkbox
                  :input-value="isSelected"
                  primary
                  hide-details
                />
              </td>

              <td
                v-for="hitem in headers_"
                v-else
                :key="hitem.value"
                class="v-data-table__mobile-row"
              >
                <div class="v-data-table__mobile-row__header">
                  {{ hitem.value == "button" ? "action" : hitem.text }}
                </div>

                <div
                  v-if="!hitem.slot"
                  class="v-data-table__mobile-row__cell"
                >
                  {{ getValue(item, hitem.value) }}
                </div>
                <div
                  v-else
                  class="v-data-table__mobile-row__cell"
                >
                  <slot
                    :name="hitem.slot"
                    :item="item"
                  />
                </div>
              </td>
            </template>
          </tr>
        </template>
      </v-data-table>
    </v-layout>
  </div>
</template>
<script>
import Store from "../../../store/index";
_ = require("lodash");
export default {
  props: {
    noSearch: { type: Boolean, default: false },
    textColor: { type: String, default: "black" },
    urlApi: { type: String },
    headers: { type: Array },
    actions: { type: Array },
    defaultSort: { type: String },
    defaultSortDesc: { type: Boolean, default: false },
  },
  data() {
    return {
      search: "",
      headers_: [],
      data_: [],
      pagination: {
        sortBy: [
          this.$props.defaultSort
            ? this.$props.defaultSort
            : this.$props.headers[0].value,
        ],
        sortDesc: [
          this.$props.defaultSortDesc ? this.$props.defaultSortDesc : false,
        ],
      },
      loading: true,
      totalData_: 0,
      has_filters: false,
      filters: {},
      checking: undefined,
      checking_key: null,
      selected: [],
    };
  },
  computed: {
    searchError() {
      return /[^a-zA-Z0-9]/.test(this.search);
    },
  },
  watch: {
    pagination: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },

    search: {
      handler() {
        this.searchData();
      },
      deep: true,
    },
    headers: {
      handler() {
        this.updateHeaders();
      },
      deep: true,
    },
  },
  mounted() {
    if (this.$attrs["checking"] !== undefined) {
      this.checking = true;
      this.checking_key = this.$attrs["checking"];
    }
  },
  created() {
    this.updateHeaders();
  },
  methods: {
    searchData: _.debounce(function(next) {
      this.fetchData();
    }, 500),

    existSlot(name) {
      return !!this.$slots[name];
    },

    getValue(object, attribute) {
      var value = attribute.split(".").reduce(function(prev, curr) {
        return prev ? prev[curr] : null;
      }, object || self);
      return value;
    },
    updateHeaders() {
      this.headers.map((item) => {
        if (item.sortable == undefined) {
          item.sortable = false;
        }
        this.$data.headers_.push(item);
      });

      this.has_filters = this.$data.headers_.filter(
        () => ["has_filter", true].length > 0
      );

      this.$data.headers_.map((o) => {
        if (o.has_filter == true) {
          o.filter = null;
        }
      });
    },

    fetchData() {
      this.$data.loading = true;
      Store.dispatch("overlay/keepOff");
      if (!this.urlApi || this.searchError) {
        this.$data.loading = false;
        return true;
      }

      window.axios
        .get(this.urlApi, {
          params: {
            query: this.$data.search,
            headers: this.$data.headers_,
            pagination: this.$data.pagination,
          },
        })
        .then((response) => {
          this.$data.data_ = response.data.items;
          this.$data.totalData_ = response.data.total;
        })
        .finally(() => {
          Store.dispatch("overlay/keepReset");
          this.$data.loading = false;
        });
    },
    changeSort(column, sortable) {
      if (!sortable) return true;
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.data_.slice();
    },

    bindAction(action) {
      let el = this;
      console.log(el);
      console.log(action);
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
  },
};
</script>
